<template>
  <div class="gmf-clickaway-overlay" v-if="isOpen" @click.stop.prevent="clickawayClick"></div>
  <div class="gmf-dropdown gmf-dropdown-select" :class="{ 'gmf-dropdown-open': isOpen }" ref="root">
    <button v-if="multiple && selectedOptions.length" class="gmf-dropdown-value gmf-dropdown-value-multiple"
      :class="{ 'gmf-dropdown-placeholder': !selectedOptions.length, 'gmf-dropdown-no-border': noBorder, 'gmf-dropdown-placeholder-alternate-styling': placeholderAlternateStyling, 'gmf-dropdown-no-padding': noPadding }" @mousedown.stop.prevent @click="toggle">
      <Icon v-if="prependIcon" :icon="prependIcon" class="gmf-dropdown-prepend-icon" />
      <span v-if="isOpen" class="gmf-dropdown-label">
        <span class="gmf-dropdown-multiple-pill" v-for="opt in selectedOptions" @mousedown.stop
          @click.stop="select(opt.value)" :key="opt.value">
          <span>{{ opt.label }}</span>
          <div class="gmf-dropdown-multiple-pill-delete">✕</div>
        </span>
      </span>
      <span v-else class="gmf-dropdown-label">
        <span class="gmf-dropdown-multiple-pill" v-for="opt in selectedOptions" :key="opt.value">
          <span>{{ opt.label }}</span>
        </span>
      </span>
    </button>
    <button v-else class="gmf-dropdown-value" :class="{ 'gmf-dropdown-placeholder': placeholder && !selectedOptions.length, 'gmf-dropdown-no-border': noBorder, 'gmf-dropdown-placeholder-alternate-styling': placeholderAlternateStyling, 'gmf-dropdown-no-padding': noPadding }"
      @mousedown.stop.prevent @click="toggle">
      <Icon v-if="prependIcon" :icon="prependIcon" class="gmf-dropdown-prepend-icon" />
      <div class="gmf-dropdown-image" v-if="selectedOption && selectedOption.imageUrl"><img
          :src="selectedOption.imageUrl" /></div>
      <span class="gmf-dropdown-label">{{ selectedLabel }}</span>
    </button>
    <div class="gmf-dropdown-contents" ref="content" v-if="isOpen" :class="{ 'gmf-dropdown-contents-alternate-styling': placeholderAlternateStyling }">
      <TextInput v-if="filterable" v-model="search" :placeholder="filterPlaceholder" @click.stop @mousedown.stop
        :autofocus="shouldAutoFocus" />
      <!-- @TODO make this a button instead of an anchor -->
      <a href="#" v-for="option in filteredOptions" :key="option.value" @mousedown.stop.prevent
        @click.stop.prevent="select(option.value)">
        <Checkbox v-if="multiple && option.value" :modelValue="selectedOptionsMap[option.value]" />
        <div class="gmf-dropdown-image" v-if="option.imageUrl"><img :src="option.imageUrl" /></div>
        <span class="gmf-dropdown-label" v-text="option.label" />
      </a>
    </div>
  </div>
</template>

<style>
.gmf-dropdown {
  position: relative;
  max-width: 100%;
}

.gmf-dropdown-select {
  display: inline-block;
  max-width: 100%;
}

.gmf-context .gmf-dropdown-value {
  font-size: var(--gmf-default-font-size);
  color: var(--gmf-col-nearblack);
  background: var(--gmf-col-white);
  border: 1px solid var(--gmf-col-gray);
  font-weight: normal;
  border-radius: var(--gmf-rounding);
  display: inline-block;
  padding: 0;
  padding-right: 42px;
  cursor: pointer;
  position: relative;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* button reset */
  margin: 0;
  text-align: left;
}

.gmf-context .gmf-dropdown-value.gmf-dropdown-no-border {
  width: unset !important;
}

.gmf-context .gmf-dropdown-no-border {
  border: none !important;
  background: none !important;
}

.gmf-dropdown-no-padding .gmf-dropdown-label {
  padding: 0 !important;
}

.gmf-dropdown-contents .gmf-text-input {
  position: sticky;
  top: 0;
  z-index: 1;
}

.gmf-context .gmf-dropdown-contents .gmf-text-input input {
  background: var(--gmf-input-bg) !important;
  border-radius: 0 !important;
  border: none !important;
  border-bottom: 1px solid var(--gmf-col-gray) !important;
  padding: var(--gmf-p-3) !important;
}

.gmf-dropdown-value:hover {
  border: 1px solid var(--gmf-col-darkgray);
}

.gmf-dropdown-value::after {
  display: block;
  width: 12px;
  background: url(https://cdn.gamifiera.com/static/icons/chevron_black.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  content: "";
  position: absolute;
  right: var(--gmf-p-4);
  top: 0;
  bottom: 0;
}

.gmf-context .gmf-dropdown-placeholder {
  color: var(--gmf-col-darkgray);
  font-style: italic;
}

.gmf-context .gmf-dropdown-placeholder-alternate-styling {
  color: unset !important;
  font-weight: bold;
  font-style: normal;
}

.gmf-dropdown-contents {
  position: absolute;
  top: 100%;
  background: var(--gmf-col-white);
  border: 1px solid var(--gmf-col-gray);
  border-radius: var(--gmf-rounding);
  z-index: 999;
  min-width: 100%;
}

.gmf-dropdown-select .gmf-dropdown-contents {
  max-width: 100%;
  width: auto;
  min-width: 100%;
  overflow: hidden;

  max-height: 335px;
  overflow-y: auto;
}

.gmf-dropdown-select .gmf-dropdown-contents.gmf-dropdown-contents-alternate-styling {
  min-width: max-content !important;
  width: max-content;
  padding-top: var(--gmf-p-3);
}

.gmf-dropdown-select .gmf-dropdown-contents.gmf-dropdown-contents-alternate-styling > a {
  width: auto !important;
  display: flex !important;
  white-space: nowrap;
}

.gmf-dropdown-select .gmf-dropdown-contents.gmf-dropdown-contents-alternate-styling .gmf-dropdown-label {
  overflow: visible;
  text-overflow: unset;
  white-space: nowrap;
}

.gmf-dropdown-label {
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.gmf-dropdown-value .gmf-dropdown-label {
  padding: var(--gmf-p-4);
}

.gmf-dropdown-contents .gmf-dropdown-label {
  padding: var(--gmf-p-3) var(--gmf-p-4);
}

.gmf-dropdown-value-multiple .gmf-dropdown-label {
  display: flex;
  flex-wrap: wrap;
  padding: var(--gmf-p-3);
  gap: var(--gmf-p-3);
}

.gmf-dropdown-contents>a {
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
}

.gmf-dropdown-contents>a:hover {
  background: var(--gmf-col-lightgray);
  color: var(--gmf-col-black);
}
.gmf-dropdown-value,
.gmf-dropdown-contents>a {
  display: inline-flex !important;
  align-items: center;
  width: 100%;
}

.gmf-dropdown-select .gmf-checkbox {
  margin-left: var(--gmf-p-4);
  flex-shrink: 0;
  pointer-events: none;
}

.gmf-dropdown-select .gmf-checkbox:not(.gmf-checkbox-checked) {
  background: var(--gmf-input-bg);
}

.gmf-dropdown-image {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding-left: var(--gmf-p-2);

  /* A small padding ensures the image doesn't touch the border */
  padding-top: 2px;
  padding-bottom: 2px;
}

.gmf-dropdown-image img {
  max-height: 100%;
  max-width: 100%;
}

.gmf-context .gmf-dropdown-multiple-pill {
  font-size: var(--gmf-text-small-font-size) !important;
  background: var(--gmf-dropdown-multiple-pill-bg);
  color: var(--gmf-dropdown-multiple-pill-col);
  border-radius: var(--gmf-rounding);
  padding: var(--gmf-p-2) var(--gmf-p-3);
  margin: var(--gmf-p-2);
  display: flex;
  gap: var(--gmf-p-2);
  align-items: center;
}

.gmf-dropdown-multiple-pill-delete {
  width: 14px;
  height: 14px;
  border-radius: 99px;
  text-align: center;
  line-height: 14px !important;
  background: var(--gmf-col-darkgray);
  color: var(--gmf-col-white) !important;
  font-size: 12px !important;
  vertical-align: middle;
  font-style: normal !important;
}

.gmf-dropdown-multiple-pill:hover .gmf-dropdown-multiple-pill-delete {
  background: var(--gmf-col-error);
}

.gmf-dropdown-open {
  z-index: 2;
}
.gmf-clickaway-overlay {
  position: fixed;
  inset: 0;
  z-index: 1;
}
</style>

<script>
import TextInput from '@/components/input/TextInput.vue';
import Checkbox from '@/components/Checkbox.vue';
import state from '@/state';
import Icon from '@/components/Icon.vue';
const t = state.t;

function getScrollRoot(el) {
  let parent = el.parentElement;
  while (parent) {
    if (parent.scrollHeight > parent.clientHeight) {
      const computedStyle = getComputedStyle(parent);
      if (computedStyle.overflowY === 'auto' || computedStyle.overflowY === 'scroll') {
        return parent;
      }
    }
    parent = parent.parentElement;
  }
  return document.body;
}

const isMobile = window?.innerWidth && window.innerWidth <= 768;

export default {
  props: ['options', 'modelValue', 'placeholder', 'filterable', 'multiple', 'noBorder', 'placeholderAlternateStyling', 'noPadding'],
  components: {
    TextInput,
    Checkbox,
    Icon,
  },
  data () {
    return {
      isOpen: false,
      search: '',

      clickawayEl: null,
    };
  },
  mounted () {
    // @TODO only when opened
    document.body.addEventListener('mousedown', this.clickawayClick);

    let el = this.$el;
    while (el) {
      if (el.classList && el.classList.contains('gmf-modal-body')) {
        this.clickawayEl = el;
        break;
      }
      el = el.parentElement;
    }
    if (this.clickawayEl) {
      this.clickawayEl.addEventListener('mousedown', this.clickawayClick);
    }
  },
  beforeUnmount () {
    document.body.removeEventListener('mousedown', this.clickawayClick);

    if (this.clickawayEl) {
      this.clickawayEl.removeEventListener('mousedown', this.clickawayClick);
    }
  },
  computed: {
    shouldAutoFocus () {
      return ! isMobile;
    },
    filterPlaceholder () {
      return t('dropdown.filter_placeholder');
    },
    filteredOptions () {
      if (!this.search) {
        return this.options;
      }
      const search = this.search.toLowerCase();
      return this.options.filter(opt => opt.label.toLowerCase().includes(search));
    },
    selectedValues () {
      let values = this.modelValue || [];
      if (! Array.isArray(values)) {
        values = [values];
      } else {
        values = [...values];
      }
      return values;
    },
    selectedOptions () {
      const options = [];
      for (const value of this.selectedValues) {
        for (const opt of this.options) {
          if (opt.value === value) {
            options.push(opt);
          }
        }
      }
      return options;
    },
    selectedOptionsMap () {
      const map = {};
      for (const opt of this.selectedOptions) {
        map[opt.value] = opt;
      }
      return map;
    },
    selectedOption () {
      return this.selectedOptions[0] || null;
    },
    valueToLabel () {
      const map = {};
      for (const opt of this.options) {
        map[opt.value] = opt.label;
      }
      return map;
    },
    selectedLabel () {
      if (this.modelValue === null || this.modelValue === undefined) {
        return this.placeholder;
      }
      return this.valueToLabel[this.modelValue] || this.placeholder;
    },
  },
  methods: {
    clickawayClick (e) {
      if (this.$refs.root.contains(e.target)) {
        return;
      }
      this.close();
    },
    toggle () {
      if (this.isOpen) {
        this.close();
        return;
      }
      this.isOpen = true;
    },
    close () {
      if (this.isOpen) {
        this.isOpen = false;
      }
    },
    select (value) {
      if (this.multiple) {
        if (value === null || value === undefined) {
          this.$emit('update:modelValue', []);
          return;
        }
        const values = this.selectedValues;
        if (values.includes(value)) {
          values.splice(values.indexOf(value), 1);
        } else {
          values.push(value);
        }
        this.$emit('update:modelValue', values);
      } else {
        this.isOpen = false;
        this.$emit('update:modelValue', value);
      }
    },
    scrollIntoView () {
      // @TODO lets make some utility function for this..

      const scrollParent = getScrollRoot(this.$el);
      const el = this.$refs.content;

      // Ensure content is in view 
      const rect = el.getBoundingClientRect();
      const scrollRect = scrollParent.getBoundingClientRect();

      const margin = 16;
      if (rect.bottom + margin > scrollRect.bottom) {
        scrollParent.scrollTop += rect.bottom + margin - scrollRect.bottom;
      }
      if (rect.top - margin < scrollRect.top) {
        scrollParent.scrollTop -= scrollRect.top - (rect.top - margin);
      }
    },
  },
  watch: {
    search () {
      this.$refs.content.scrollTop = 0;
    },
    isOpen (isOpen) {
      if (isOpen) {
        this.search = '';

        // this.$nextTick(this.scrollIntoView);
      }
    },
  },
}
</script>
